import { FieldErrorProps } from '@rjsf/utils';
import React, { memo } from 'react';

const FieldErrorTemplate = memo((props: FieldErrorProps) => {
	const { errors } = props;
	return <div>
		{errors?.map((error: string, idx: number) => {
			if (error === 'form.validation.const' || error === 'form.validation.oneOf') {
				return null;
			}

			return (
				<span key={idx} className="text-xs text-red-500">
					{error}
				</span>
			);
		})}
	</div>
});

export { FieldErrorTemplate };
